import { gql, TypedDocumentNode } from "@apollo/client";

import { QuerySearchRevisionsSuggestionsArgs, SearchSuggestionsOutput } from "types/generated";
import { SEARCH_SUGGESTIONS_FRAGMENT } from "constants/suggestions";

export const SEARCH_SPACELIFT_VCS_REPO_REVISIONS_SUGGESTIONS: TypedDocumentNode<
  {
    searchRevisionsSuggestions: SearchSuggestionsOutput;
  },
  QuerySearchRevisionsSuggestionsArgs
> = gql`
  query SearchSpaceliftVcsRepoRevisionsSuggestions($input: SearchSuggestionsInput!, $repoID: ID!) {
    searchRevisionsSuggestions(input: $input, repoID: $repoID) {
      ...SearchSuggestionsFragment
    }
  }
  ${SEARCH_SUGGESTIONS_FRAGMENT}
`;
